<ion-content>
	<ion-col class="ion-no-padding">
		<ion-row
			[class.mode-wrapper]="showMap"
			class="ion-justify-content-end ion-margin ion-hide-lg-up view-picker"
			role="region"
			aria-label="View picker"
		>
			<ion-icon
				(click)="showMap = false"
				[class.selected]="!showMap"
				[src]="!showMap ? '/assets/icon/icon-list.svg' : '/assets/icon/icon-list-gray.svg'"
				class="mode-icon"
				size="medium"
				role="img"
				aria-label="Toggle map view"
			>
			</ion-icon>
			<ion-icon
				(click)="showMap = true"
				[class.selected]="showMap"
				[src]="!showMap ? '/assets/icon/icon-map-gray.svg' : '/assets/icon/icon-map.svg'"
				class="mode-icon"
				size="medium"
				role="img"
				aria-label="Toggle map view"
			>
			</ion-icon>
		</ion-row>
		<ion-row class="flex-grow overflow-auto">
			<ion-col [class.ion-hide-lg-down]="!showMap" class="ion-no-padding" size="12" size-lg="8">
				<div #mapContainer id="map" role="region" aria-label="Map container"></div>
			</ion-col>
			<ion-col [class.align-bottom]="showMap" class="ion-no-padding full-height-overflow" size="12" size-lg="4">
				<div *ngIf="!loading" class="venues ion-padding" role="region" aria-label="Venues content">
					<h1 class="title">{{'venue_suggestion.title' | translate}}</h1>
					<ng-container *ngIf="showMap">
						<app-venue-suggestion
							(click)="setupMap(selectedVenue, venues)"
							(venuePick)="selectVenue($event.venue)"
							[selected]="true"
							[type]="preorderType"
							[venue]="selectedVenue"
						></app-venue-suggestion>
					</ng-container>
					<ng-container *ngIf="!showMap">
						<app-venue-suggestion
							(click)="setupMap(venue, venues)"
							(venuePick)="selectVenue($event.venue)"
							*ngFor="let venue of venues"
							[selected]="selectedVenue && selectedVenue._id === venue._id"
							[type]="preorderType"
							[venue]="venue"
						></app-venue-suggestion>
					</ng-container>
				</div>
			</ion-col>
		</ion-row>
		<ion-row *ngIf="loading" class="center light-grey-transparent" role="region" aria-label="Loading content">
			<ion-spinner class="main-color" name="crescent"></ion-spinner>
		</ion-row>
	</ion-col>
</ion-content>
